import { render, staticRenderFns } from "./BaseHeaderStats.vue?vue&type=template&id=24ba3001"
import script from "./BaseHeaderStats.vue?vue&type=script&lang=js"
export * from "./BaseHeaderStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports